var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { repeat } from 'lit/directives/repeat.js';
import { property, state } from 'lit/decorators.js';
import { query } from 'lit/decorators.js';
import { html, css } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { booleanDecoder, stringDecoder, numberDecoder, customElement, doSubmit, PICAction, PICBase, PIC } from '../Internals';
let PICUpload = class PICUpload extends PICBase {
    getTxt(key) {
        let objKey = PIC.getInstance.userConfig.userLang.replace('-', '').toLowerCase();
        if (!['engb', 'dadk', 'dede'].includes(objKey))
            objKey = 'engb';
        return this.langobj_[objKey][key];
    }
    set isExtraVisible(isExtraVisible) {
        this.isExtraVisible_ = isExtraVisible;
        this.requestUpdate();
    }
    get isExtraVisible() {
        return this.isExtraVisible_;
    }
    // "ok" -> add to this list/array or whatever.. make sure it works 
    get files_() {
        if (this.fileFld && this.fileFld.files)
            return this.fileFld.files;
        // returnere hvad der er i den interne -> fjerner alle filerne
    }
    set uploadedFiles(iFiles) {
        this.uploadedFiles_ = iFiles;
        this.requestUpdate();
    }
    get uploadedFiles() {
        return this.uploadedFiles_;
    }
    constructor() {
        super();
        this.width = 0;
        this.multiple_ = false;
        this.fileTypes_ = '';
        this.succesEvent_ = '';
        this.allowDelete_ = true; // deprecated. Does not work
        this.preventDelete_ = false;
        this.isModalOpen = false;
        this.buttonWidth = 142;
        this.canDrop = false;
        this.isExtraVisible_ = false;
        this.langobj_ = {
            engb: { upload: 'Upload', selectFiles: 'Select files', showFiles: 'Show files', cancel: 'Cancel', confirm: 'Ok', modalTitle: 'File overview', cancelAll: 'Deselect all', dragAndDrop: 'Drag and drop Files', or: 'or', confirmDelete: 'Are you sure you want to delete ', yes: 'Yes', no: 'No', errorDelete: 'Could not delete file, please try again' },
            dadk: { upload: 'Upload', selectFiles: 'Vælg filer', showFiles: 'Vis filer', cancel: 'Annuler', confirm: 'Ok', modalTitle: 'Filoversigt', cancelAll: 'Fravælg alle', dragAndDrop: 'Træk og slip filer', or: 'eller', confirmDelete: 'Er du sikker på at du vil slette ', yes: 'Ja', no: 'Nej', errorDelete: 'Kunne ikke slette filen, prøv venligst igen' },
            dede: { upload: 'Hochladen', selectFiles: 'Dateien auswählen', showFiles: 'zeige Dateien', cancel: 'Abbrechen', confirm: 'Ok', modalTitle: 'Dateiübersicht', cancelAll: 'Alle abwählen', dragAndDrop: 'Dateien ziehen und ablegen', or: 'oder', confirmDelete: 'Sind Sie sicher, dass Sie löschen möchten ', yes: 'Ja', no: 'Nein', errorDelete: 'Datei konnte nicht gelöscht werden, bitte versuchen Sie es erneut' },
        };
    }
    static get styles() {
        const defaultStyle = css `
            :host{
                --pic-fontColor: 
                    linear-gradient(to right, var(--pic-onSurfaceMediumColor), var(--pic-onSurfaceMediumColor)),
                    linear-gradient(to right, var(--pic-backgroundColor), var(--pic-backgroundColor));
            }   
            .inner-input {
                width: 100%;
                box-sizing: border-box;
                font-family: monospace;
            }
            .button {
                border-radius: 0;
                -webkit-appearance: none;
                text-align: center;
                font-size: 1em;
                width: 100%;
                background: rgba(0, 0, 0, .63);
                background: var(--buttonColor);
                border: 1px solid black;
                color: white;
                height: 30px;
                cursor: pointer;
            }
            .pic-subtitle1 {
                color: var(--pic-onSurfaceMediumColor);
            }
            .pic-subtitle2 {
                color: var(--pic-onSurfaceDisabledColor);
            }
            .upload-container {
                padding: 28px;
                width: 'fit-content';
                background-color: var(--pic-surfaceColor);
                /* border: 2px dashed rgba(0, 0, 0, 0.12); */
                display: flex;
                flex-direction: column;
                align-items: center;
                background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='rgba(0, 0, 0, 0.12)' stroke-width='2' stroke-dasharray='5' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
            }
            .upload-icon::after {
                content: '\u{F0A4D}';
                font-family: "Material Design Icons";
                width: 40px;
                height: 16px;
                font-style: normal;
                font-weight: 400;
                font-size: 40px;
                line-height: 16px;
                color: var(--pic-onSurfaceDisabledColor);
            }
            .upload-container.extravisible {
                background-color: var(--pic-backgroundColor);
                stroke: var(--pic-primaryColor);
            }
            .upload-container.canDrop {
                background-color: var(--pic-backgroundColor);
                stroke: var(--pic-statusOkColor);
            }
            .upload-buttons {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                column-gap: 24px;
            }

            .closeicon{
                
            }
            .closeicon::before{
                font-family: "Material Design Icons";
                color: var(--pic-onSurfaceHighColor);
                content: '\u{F0156}';
                cursor: pointer;
                height: 14px; 
                width: 14px;
            }
            .upload-modal{
                position: fixed;
                top:15%;
                left:-20%;
                right:0;
                z-index: 21;
                
                margin-left: auto;
                margin-right: auto;
                
                width: 40%;
                height: 40%;
                border-radius: 4px;
                box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);

                padding-left: 20px;
                padding-right: 20px;
                padding-bottom: 20px;

                background-color: var(--pic-surfaceColor);

                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
            .header{ 
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            
            .bodycontainer{
                align-self: flex-start;
                overflow-y: auto; 
                height: 69%;
                width: 100%;
            }

            .fileline{
                display: flex;
                flex-direction: row;
                align-items: flex-start;
            }
            .fileline .pic-overline{
                line-height: 24px;
            }
            .iconholder{
                font-family: "Material Design Icons";
                min-width: 24px;
                width: 24px;
                height: 24px;
            }
            .iconholder.cross::before{
                color: var(--pic-chipIconColor);
                cursor: pointer;
                content: '\u{F0159}';
                line-height: 24px;
                padding-left: 4px;
            }
            .iconholder.warning::before{
                color: var(--pic-statusErrorColor);
                content: '\u{F02FD}';
                line-height: 24px;
                padding-left: 4px;
            }
            .iconholder.checked::before{
                color: var(--pic-statusOkColor);
                content: '\u{F05E0}';
                line-height: 24px;
                padding-left: 4px;
            }
            .iconholder.progressindicator{
                color: var(--pic-statusOkColor);
                line-height: 24px;
                font-size: 15px;
            }

            .ellipsistext{
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .footer{
                align-self: flex-end;
                bottom: 0px;

                height: 50px;
                min-height: 50px;
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.fileClickAction = new PICAction();
        this.openModalAction = new PICAction();
        this.uploadClickAction = new PICAction();
        this.deselectAllAction = new PICAction();
        PIC.getInstance.events.addUploadField(this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        PIC.getInstance.events.removeUploadField(this);
    }
    firstUpdated() {
        this.fileClickAction.type_ = 'internal';
        this.fileClickAction.eventFnc = (() => { this.fileFld.click(); }).bind(this);
        // Annuller -> clear upload (dont do that) 
        this.openModalAction.type_ = 'internal';
        this.openModalAction.eventFnc = this.openModal.bind(this);
        this.uploadClickAction.type_ = 'internal';
        this.uploadClickAction.eventFnc = this.handleUpload2ElectricBoogaloo.bind(this);
        this.deselectAllAction.type_ = 'internal';
        this.deselectAllAction.eventFnc = this.deselectAll.bind(this);
        this.getUploadedFiles();
    }
    async getUploadedFiles() {
        await fetch(`../filestore/UploadFormFile?notekey=${this.noteKey_}&company=${this.user_.split('_')[0]}&system=${PIC.getInstance.systemId}`).then(async (resp) => {
            if (resp.ok) {
                let files = await resp.text()
                    .then(d => d.replace(new RegExp(this.noteKey_ + "-", 'g'), ""))
                    .then(data => data.split(','));
                this.uploadedFiles = files;
            }
        })
            .catch((errResp) => { });
    }
    getFileTypeRegExStr() {
        if (this.fileTypes_) {
            let res = this.fileTypes_.split(',').join('|\\');
            if (res.length > 0)
                return '\\' + res;
        }
        return '\.pdf|\.png|\.jpg|\.txt|\.xlsx';
    }
    isAllFilesValid() {
        let reg = new RegExp('(' + this.getFileTypeRegExStr() + ')$', 'i');
        let valid = true;
        if (this.files_)
            for (var i = 0; i < this.files_.length; i++) {
                if (!this.files_[i].name.match(reg)) {
                    valid = false;
                }
                ;
            }
        ;
        return valid;
    }
    ;
    isFileValid(iFile) {
        let reg = new RegExp('(' + this.getFileTypeRegExStr() + ')$', 'i');
        return !!iFile.name.match(reg);
    }
    getNumberOfValidFiles() {
        let res = 0;
        if (this.files_)
            Array.from(this.files_).forEach(file => {
                if (this.isFileValid(file))
                    res++;
            });
        return res;
    }
    async newUploadSingleFile(iFile, iDomElm) {
        let formData = new FormData;
        formData.append('file', iFile);
        formData.append('notekey', this.noteKey_);
        formData.append('company', this.user_.split('_')[0]);
        formData.append('username', this.user_);
        formData.append('system', PIC.systemId);
        let ref = this;
        return new Promise(function (resolve, reject) {
            let xhr = new XMLHttpRequest();
            xhr.upload.addEventListener('progress', (e) => ref.uploadProgress(e, ref.shadowRoot.getElementById('fl0')), false);
            xhr.onreadystatechange = function () {
                if (this.readyState == 4)
                    resolve(this.responseText);
                else if (this.readyState > 4)
                    reject('Upload of file: ' + iFile.name + ' failed');
            };
            xhr.open('POST', '/filestore/UploadFormFile', true);
            xhr.send(formData);
            function uploadProgress2(e) {
                iDomElm.innerText = Math.round(e.loaded / e.total * 100) + '';
            }
        });
    }
    uploadSingleFile(iFile) {
        let formData = new FormData;
        formData.append('file', iFile);
        formData.append('notekey', this.noteKey_);
        formData.append('company', this.user_.split('_')[0]);
        formData.append('username', this.user_);
        formData.append('system', PIC.systemId);
        let ref = this;
        return new Promise(function (resolve, reject) {
            let xhr = new XMLHttpRequest();
            xhr.upload.addEventListener('progress', (e) => ref.uploadProgress(e, ref.shadowRoot.getElementById('fl0')), false);
            xhr.onreadystatechange = function () {
                if (this.readyState == 4)
                    resolve(this.responseText);
                else if (this.readyState > 4)
                    reject('Upload of file: ' + iFile.name + ' failed');
            };
            xhr.open('POST', '/filestore/UploadFormFile', true);
            xhr.send(formData);
        });
    }
    uploadProgress(e, refStateElem) {
        let progress = Math.round(e.loaded / e.total * 100);
        refStateElem.innerText = progress + '%';
    }
    handleUpload() {
        let ref = this;
        if (!ref.isAllFilesValid()) {
            doSubmit('', { choiceBox: { hasChoiceBox: true, customBox: { choiceTitle: 'Invalid filetype selected! Supported types are: ' + ref.fileTypes_, choices: [] } } });
        }
        else {
            let reqs = [];
            if (ref.files_)
                for (var i = 0; i < ref.files_.length; i++) {
                    reqs.push(ref.uploadSingleFile(ref.files_[i]));
                }
            ;
            Promise.all(reqs).then(function () {
                /* NEEDS USEREVENT REF */
                doSubmit(ref.succesEvent_ ? ref.succesEvent_ : 'refresh');
            }).catch(function (reason) {
            });
        }
        ;
    }
    ;
    getFirstValidFile() {
        if (this.files_) {
            return Array.from(this.files_).find(f => { return this.isFileValid(f); });
        }
        return undefined;
    }
    async handleUpload2ElectricBoogaloo() {
        let ref = this;
        if (this.files_) {
            if (this.getNumberOfValidFiles() > 0) {
                let file = this.getFirstValidFile();
                this.uploadSingleFile(file).then(r => {
                    ref.handleDeselectFile(file);
                    this.uploadedFiles.unshift(file.name);
                    ref.requestUpdate();
                    ref.handleUpload2ElectricBoogaloo();
                });
            }
        }
        /*let success = true;
        if(this.files_){
            if(!this.isAllFilesValid()){
                doSubmit('', {choiceBox:{hasChoiceBox:true, customBox: {choiceTitle:'Invalid filetype selected! Supported types are: ' + this.fileTypes_, choices:[]}}});
            } else {
                for(let i = 0; i < this.files_.length, i++;){
                    let elm = this.shadowRoot?.querySelector('fl' + i) as HTMLDivElement;
                    await this.newUploadSingleFile(this.files_[i], elm).then(function(){
                        elm.classList.add('iconholder')
                        elm.classList.add('complete')
                    }).catch(function(){
                        elm.classList.add('iconholder')
                        elm.classList.add('failed')
                        success = false;
                    });
                }
            }
        }
        if(success){
            
        } else {

        }*/
    }
    dropHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        this.canDrop = false;
        PIC.getInstance.events.toggleUploadFields('Files', undefined, false);
        if (e.dataTransfer) {
            this.fileFld.files = e.dataTransfer.files;
            this.fileFld.dispatchEvent(new Event('change'));
        }
    }
    preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    ;
    fileLstChanged(e) {
        if (this.files_) {
            // //TODO delete this loop
            // for(let file of this.files_){
            //     console.log(file)
            // }
            this.isModalOpen = true;
        }
        this.requestUpdate();
    }
    getContainerClass() {
        return {
            'upload-container': true,
            'pic-subtitle1': true,
            'canDrop': this.canDrop,
            'extravisible': this.isExtraVisible_
        };
    }
    handleDragLeave() {
        this.preventDefaults;
        this.canDrop = false;
        this.requestUpdate();
    }
    handleDragEO() {
        this.preventDefaults;
        this.canDrop = true;
        this.requestUpdate();
    }
    renderDropable() {
        this.requestUpdate();
    }
    /* send delete command to filestore if user confirms */
    confirmDeleteFile(iFileName) {
        let ref = this;
        doSubmit('', {
            choiceBox: {
                hasChoiceBox: true,
                customBox: {
                    choiceTitle: this.getTxt('confirmDelete') + iFileName + '?',
                    choices: [
                        {
                            choiceText: this.getTxt('yes'),
                            choiceEvent: 'si',
                            eventFnc: () => { this.handleDeleteFile.bind(ref)(iFileName); }
                        }, {
                            choiceText: this.getTxt('no'),
                            choiceEvent: ''
                        }
                    ]
                }
            }
        });
    }
    /* actual delete file command */
    handleDeleteFile(iFileName) {
        let dotSplt = iFileName.split('.');
        let dashSplt = dotSplt[0].split('-');
        fetch(`/filestore/FileDeleteSrv?notekey=${this.noteKey_}&system=${PIC.getInstance.systemId}&timestamp=${dashSplt[1]}&username=${dashSplt[0]}&filetype=${dotSplt[1]}`)
            .then(async (resp) => {
            if (resp.ok && resp.status == 200) {
                await resp.text().then(rt => {
                    if (rt.toLowerCase() == 'ok') {
                        this.uploadedFiles.splice(this.uploadedFiles.indexOf(iFileName), 1);
                        this.requestUpdate();
                    }
                    else {
                        doSubmit('', {
                            choiceBox: {
                                hasChoiceBox: true,
                                customBox: {
                                    choiceTitle: this.getTxt('errorDelete'),
                                    choices: [
                                        {
                                            choiceText: this.getTxt('confirm'),
                                            choiceEvent: '',
                                        }
                                    ]
                                }
                            }
                        });
                    }
                });
            }
        })
            .catch((errResp) => {
            doSubmit('', {
                choiceBox: {
                    hasChoiceBox: true,
                    customBox: {
                        choiceTitle: this.getTxt('errorDelete'),
                        choices: [
                            {
                                choiceText: this.getTxt('confirm'),
                                choiceEvent: '',
                            }
                        ]
                    }
                }
            });
        });
    }
    /* only way to deselect a file for a input field,
     is to create a new DataTransfer object and use the fileList from that */
    handleDeselectFile(iFileToDeselect) {
        var _a;
        let newFileList = new DataTransfer();
        if (this.files_) {
            (_a = Array.from(this.files_)) === null || _a === void 0 ? void 0 : _a.forEach(file => {
                if (file !== iFileToDeselect) {
                    newFileList.items.add(file);
                }
            });
        }
        this.fileFld.files = newFileList.files;
        this.requestUpdate();
    }
    deselectAll() {
        this.fileFld.files = new DataTransfer().files;
        this.requestUpdate();
    }
    ;
    openModal() {
        this.isModalOpen = true;
        this.requestUpdate();
    }
    closeModal() {
        this.isModalOpen = false;
        this.requestUpdate();
    }
    getValidIconClassMap(iFile) {
        let valid = this.isFileValid(iFile);
        return {
            iconholder: true,
            warning: !valid,
            progressindicator: valid
        };
    }
    getCrossIconClassMap() {
        return {
            iconholder: true,
            cross: !this.preventDelete_,
        };
    }
    renderFileLine(iFile, index) {
        return html `
            <div class="fileline">
                <div class="iconholder cross" @click=${() => { this.handleDeselectFile(iFile); }}></div>
                <div id=${'fl' + index} class=${classMap(this.getValidIconClassMap(iFile))}></div>
                <div class="pic-body1 ellipsistext">${iFile.name}</div>
                <div class="pic-overline" style="--pic-onSurfaceHighColor: var(--pic-onSurfaceMediumColor);">&nbsp;~${(Math.round((iFile.size / 1e+6) * 100) / 100).toFixed(2)}MB</div>
            </div>
        `;
    }
    renderUploadedFileLine(iFileName, index) {
        let isNoFilesIcon = iFileName.trim() === 'No files found!';
        let showNoFilesFound = (this.uploadedFiles.length == 1 && isNoFilesIcon) || this.uploadedFiles.length == 0;
        if (showNoFilesFound) {
            return html `
            <div class="fileline">
                <div class="pic-body1 ellipsistext">${iFileName}</div>
            </div>`;
        }
        else {
            return html `
            ${!isNoFilesIcon ? html `
                <div class="fileline">
                    <div class=${classMap(this.getCrossIconClassMap())} @click=${() => { if (!this.preventDelete_)
                this.confirmDeleteFile(iFileName); }}></div>
                    <div id=${'ufl' + index} class="iconholder checked"></div>
                    <div class="pic-body1 ellipsistext">${iFileName}</div>
                </div>

                ` : ''}
            `;
        }
    }
    renderFileList() {
        if (this.isModalOpen) {
            return html `
                <div class="upload-modal">
                    <div class="header">
                        <p class="pic-h6">${this.getTxt('modalTitle')}</p>
                        <p class="closeicon" @click=${this.closeModal}></p>
                    </div>
                    <div class="bodycontainer">
                        ${this.files_ ? repeat(this.files_, (item, index) => this.renderFileLine(item, index)) : ''}
                        ${this.uploadedFiles.length > 0 ? repeat(this.uploadedFiles, (item, index) => this.renderUploadedFileLine(item, index)) :
                this.renderUploadedFileLine('No files found!', 0)}
                    </div>
                    <div class="footer">
                        ${this.renderFooterButtons()}
                    </div>
                </div>
            `;
        }
        return '';
    }
    renderFooterButtons() {
        let numValid = this.getNumberOfValidFiles();
        if (numValid > 0)
            return html `
            <pic-button 
                .action=${this.deselectAllAction} 
                etype='text' 
                density="low" 
                width=${this.buttonWidth} 
                label=${this.getTxt('cancelAll')}>
            </pic-button>
            <pic-button 
                .action=${this.uploadClickAction} 
                etype='contained' 
                density='low' 
                width=${this.buttonWidth} 
                label=${this.getTxt('upload') + ' (' + numValid + ')'}>
            </pic-button>
        `;
    }
    render() {
        return html `
            ${this.renderCSS(true)}
            <div class=${classMap(this.getContainerClass())}
                @drop=${this.dropHandler}
                @dragenter=${this.handleDragEO}
                @dragleave=${this.handleDragLeave}
                @dragover=${this.handleDragEO}>
                <input 
                    type="file" 
                    ?multiple=${this.multiple_}
                    id="fileInput"
                    name="fileInput"    
                    style="display:none;"
                    accept=${this.fileTypes_}
                    @change=${this.fileLstChanged}
                    >
                <div class='upload-icon'></div>
                <p>${this.getTxt('dragAndDrop')}</p>
                <p class='pic-subtitle2'>${this.getTxt('or')}</p>
                <div class='upload-buttons'>
                    <pic-button .action=${this.fileClickAction} type='button' etype='outlined' density='low' width='fit-content' label=${this.getTxt('selectFiles')}></pic-button>
                    <pic-button .action=${this.openModalAction} type='button' etype='contained' density='low' width='fit-content' label=${this.getTxt('showFiles')}></pic-button>
                </div>
            </div>
            ${this.renderFileList()}
        `;
    }
};
__decorate([
    property({ converter: numberDecoder })
], PICUpload.prototype, "width", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'multiple' })
], PICUpload.prototype, "multiple_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'filetypes' })
], PICUpload.prototype, "fileTypes_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'notekey' })
], PICUpload.prototype, "noteKey_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'user' })
], PICUpload.prototype, "user_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'succesevent' })
], PICUpload.prototype, "succesEvent_", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'allowdelete' })
], PICUpload.prototype, "allowDelete_", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'preventdelete' })
], PICUpload.prototype, "preventDelete_", void 0);
__decorate([
    query('#fileInput')
], PICUpload.prototype, "fileFld", void 0);
__decorate([
    state()
], PICUpload.prototype, "uploadProgres", void 0);
PICUpload = __decorate([
    customElement('pic-upload')
], PICUpload);
export { PICUpload };
//# sourceMappingURL=PICUpload.js.map